// import { pink, indigo } from "@material-ui/core/colors"

import { createTheme } from '@material-ui/core/styles'


// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#607d8b'
    },
    secondary: {
      main: '#e91e63'
    },
  },
})

export default theme